export default __webpack_public_path__ + "images/c20a17c744aaa708233216ee0aa465fb.svg";